const NavPage = [
  {
    title: "HOME",
    path: "/",
  },
  {
    title: "POPULAR",
    path: "/popular",
  },
  {
    title: "COMING SOON",
    path: "/coming_soon",
  },
  {
    title: "TRENDING",
    path: "/trending",
  },
];

export default NavPage;
